/* global wp */
/* eslint-disable */

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText } = wp.editor;
const { InnerBlocks, InspectorControls } = wp.blockEditor;
const { PanelBody, RadioControl, RangeControl, TextControl } = wp.components;

registerBlockType(
  'cjbs/tabs-inner',
  {
    title: __('Tabs/Pills inner (CJBS)', 'stella'),
    description: __('A custom tab or pill. This block can only be used within the "Tabs/Pills (CJBS)" block.', 'stella'),
    parent: ['cjbs/tabs'],
    icon: 'index-card',
    category: 'layout',
    keywords: [
      __('tabs', 'stella'),
      __('pills', 'stella'),
    ],
    attributes: {
      blockIndex: {
        type: 'number'
      },
      nested: {
        type: 'boolean',
        default: false
      }
    },

    edit: (props) => {
      const { attributes } = props;
      var subItem = attributes.nested ? `1-` : "";

      return (
        <div
          className={'b22__tab-pane' + (attributes.blockIndex === 0 ? ' is-active' : '')}
          id={'item' + subItem  + (attributes.blockIndex + 1)}
          data-tab-target={'item' + subItem + (attributes.blockIndex + 1)}
          data-parent-index={attributes.blockIndex + 1}
        >
          <div className="campl-no-bottom-padding">
            <InnerBlocks
              templateLock={false}
              renderAppender={() => (
                <InnerBlocks.ButtonBlockAppender />
              )}
            />
          </div>
        </div>
      );
    },
    save: (props) => {
      const { attributes } = props;
      //sub item shows parent tab when nested tabs exist
      var subItem = attributes.nested ? `1-` : "";


      return (
        <div
          className={'b22__tab-pane' + (attributes.blockIndex == 0 ? ' is-active' : '')}
          id={'item' + subItem + (attributes.blockIndex + 1)}
          data-tab-target={'item' + subItem + (attributes.blockIndex + 1)}
          data-parent-index={attributes.blockIndex + 1}
        >
          <div className="campl-no-bottom-padding">
            <InnerBlocks.Content />
          </div>
        </div>
      );
    }
  }
);
